import * as React from "react";
import { Box, Skeleton } from "@mui/material";
/* Array.from(Array(10).keys()) */
function ActivitySkelton(props) {
  let { count = 6, hideAvatar } = props;
  return Array.from(Array(count).keys()).map((_, idx) => (
    <Box
      key={idx}
      sx={{
        display: 'flex',
        alignItems: 'center',
        background: '#fff',
        borderRadius: '18px',
        boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)',
        p: 1.25,
        pl: 1.75,
        pr: 2.5,
        mb: 1.25,
        minHeight: 48
      }}
    >
      {!hideAvatar && (
        <Skeleton variant="circular" width={36} height={36} sx={{ mr: 2.25 }} />
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="text" height={18} width="40%" sx={{ mb: 0.5 }} />
        <Skeleton variant="text" height={14} width="60%" />
      </Box>
      <Skeleton variant="text" height={14} width={80} sx={{ mx: 1.25 }} />
      <Skeleton variant="circular" width={21} height={21} />
    </Box>
  ));
}
export default ActivitySkelton;
